import Styled from "styled-components";

const CalendarWrapper = Styled.div`
	width: 100%;
	.calender-container {
		display: flex;
		justify-content: center;
	}
	.react-calendar {
		/* margin-left: 10px; */
		width: ${(props) => (props.desktop ? "80%" : "100%")};
	}
	.react-calendar__navigation button[disabled] {
		background: transparent;
	}
	.react-calendar__month-view__weekdays__weekday {
		padding: 1.5em;
	}
	abbr[title] {
		text-decoration: none;
	}
	.react-calendar {
		border: none;
	}
	.react-calendar__navigation__next2-button,
	.react-calendar__navigation__prev2-button {
		display: none;
	}
	.react-calendar__tile {
		font-family: "Montserrat", sans-serif;
	}
	.react-calendar__navigation__arrow,
	.react-calendar__navigation__prev-button {
		color: #a157b0;
		font-weight: 500;
		font-size: 32px;
	}
	.react-calendar__month-view__weekdays__weekday {
		font-family: "Montserrat", sans-serif;
	}
	.react-calendar__navigation__label {
		color: #a157b0;
		font-weight: 600;
		font-size: 14px;
	}
	.react-calendar__tile--active:enabled:hover,
	.react-calendar__tile--active:enabled:focus {
		background: #fcf1ff;
		color: #000;
	}
	.react-calendar__tile--active {
		border: 1px solid #9248a3;
		background: #fcf1ff;
		color: #000;
	}

	.react-calendar__tile--now {
		border: 1px solid #9248a3;
		background-color: transparent;
	}
	.react-calendar__tile {
		padding: 1em 0.85em;
	}
	.current-step-label {
		color: #8c8c8c;
		font-size: 12px;
	}
	.react-calendar__month-view__weekdays {
		border-bottom: 1px solid #f0f0f0;
		color: #757575;
	}
	.react-calendar__tile:disabled {
		background: transparent;
		abbr {
			color: #d5cdcd;
		}
	}
	.react-calendar__tile:enabled:hover,
	.react-calendar__tile:enabled:focus {
		background-color: #fcf1ff;
	}
	.react-calendar__navigation__label__labelText,
	.react-calendar__navigation__label__labelText--from {
		font-family: "Montserrat", sans-serif;
	}
	.react-calendar__navigation {
		justify-content: center;
		font-family: "Montserrat", sans-serif;
	}
	.react-calendar__navigation__label {
		flex-grow: 0.5 !important;
	}
	.react-calendar__month-view__days__day--weekend {
		color: #000;
	}
	.react-calendar__month-view__days__day--neighboringMonth {
		color: #8c8c8c;
	}
	.react-calendar__navigation__arrow:disabled {
		color: #8c8c8c;
	}
`;

const WrapperBack = Styled.div`
  margin-top: 16px
`;

export { CalendarWrapper, WrapperBack };
